import React, {useContext} from 'react'
import {Form, Input} from "antd";
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeProductionName = ({rowId}) => {

    const [form] = Form.useForm()
    const {productionData} = useContext(RecipeConText)
    const [productionCosts, setProductionCosts] = productionData


    const handleNameChange = (list) => {
        let mockProducts = Object.assign({}, productionCosts)
        mockProducts[rowId].name = list.productionName
        // mockProducts[rowId].id = list.row
        setProductionCosts(mockProducts)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span:24}}
            >
                <Form.Item
                    initialValue={productionCosts[rowId].name}
                    name={'productionName'}
                >
                    <Input  onChange={() => handleNameChange(form.getFieldsValue())} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default RecipeProductionName